<template>
    <section class="section-lesson-files" :class="color" v-if="videos?.length || audios?.length || documents?.length">
        <LayoutContained :class="padding">
            <div v-for="(file, index) in videos" v-bind:key="index" class="pb-3">
                <h2 class="mb-3 text-3xl font-bold" v-if="!file.file_mp4 && !file.file_webm">{{ file.file_name }}</h2>
                <EmbedFileVideoTranscoded v-if="file.file_mp4 && file.file_webm" v-bind="{file: excerpt(file)}"></EmbedFileVideoTranscoded>
                <EmbedFileVideo v-else v-bind="{file: excerpt(file)}"></EmbedFileVideo>
            </div>
            <div v-for="(file, index) in audios" v-bind:key="index" class="pb-4">
                <h2 class="mb-3 text-lg font-bold text-zinc-700 sm:text-2xl">{{ file.file_name }}</h2>
                <EmbedFileAudio v-bind="{file: excerpt(file)}"></EmbedFileAudio>
            </div>
            <div v-if="documents.length" class="mt-12 only:mt-0">
                <div class="flex">
                    <h2 class="mb-5 text-2xl font-bold text-zinc-700">
                        File Downloads
                    </h2>
                    <IconDownload class="ml-2 mt-0.5 text-zinc-800"></IconDownload>
                </div>
                <div class="flex flex-wrap gap-5">
                    <EmbedFileDocument v-for="(file, index) in documents" v-bind:key="index" v-bind:file="excerpt(file)" class="flex-grow sm:flex-grow-0"></EmbedFileDocument>
                </div>
            </div>
        </LayoutContained>
    </section>
</template>

<script>
export default {
    name: 'SectionLessonFiles',
    props: {
        lesson: {
            required: true,
            type: Object,
            default () {
                return {};
            },
        },
        padding: {
            required: false,
            default: 'py-7',
            type: String,
        },
        color: {
            required: false,
            type: String,
            default: 'bg-zinc-100',
        },
    },
    computed: {
        files () {
            return this.lesson?.lesson_files || [];
        },
        videos () {
            if (!this.files || !this.files.length) return [];
            let videos = this.files.filter(file => file.file_extension === 'mp4');
            // Remove first video as it is displayed as the main embed
            videos.shift(); // TODO - ideally we would check if this matches the first embed in lesson.lesson_video_sources
            return videos;
        },
        audios () {
            if (!this.files || !this.files.length) return [];
            let result = [];
            for (let i = 0; i < this.files.length; ++i) {
                if (['mp3'].indexOf(this.files[i].file_extension) !== -1) {
                    result.push(this.files[i]);
                }
            }
            return result;
        },
        documents () {
            if (!this.files || !this.files.length) return [];
            let result = [];
            for (let i = 0; i < this.files.length; ++i) {
                if (['pdf'].indexOf(this.files[i].file_extension) !== -1) {
                    result.push(this.files[i]);
                }
            }
            return result;
        },
    },
    methods: {
        excerpt: function (file) {
            return {
                name: file.file_name,
                extension: file.file_extension,
                url: file.file_url,
                poster: file.file_poster,
                mp4: file.file_mp4,
                webm: file.file_webm
            };
        },
    }
};
</script>
